
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, union_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Feature, isFeatureEnabled } from "../FeatureFlip.js";
import { PermissionScope, Permissions_scopeAtLeast, Permission, Permissions_has } from "../Shared/Roles.js";
import { join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { ToolId__get_unwrap, StocktakingListId__get_unwrap, StocktakingId__get_unwrap } from "../Shared/Shared.js";
import { SetStocktakingHistoryDto_$reflection, StocktakingHistoryPositionDto_$reflection, StocktakingHistoryHeadDto_$reflection, InventoryStocktakingHistoryDto_$reflection, StocktakingState__ToI18nString, ReceiverStocktakingHistoryDto_$reflection, StocktakingHistory_running, StocktakingHistory_lastCompleted, StocktakingHistoryCorrectionKind__ToI18nString } from "../Shared/Stocktaking.js";
import { unwrap, map as map_1, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, equals, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextValue } from "../Components/Text.js";
import { TextButton } from "../Components/Button.js";
import { RouterModule_encodeParts, RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { collect, tail, empty, toArray, isEmpty, singleton as singleton_1, tryFind, map, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Skeleton } from "../Components/Skeleton.js";
import { ErrorAlert } from "../Components/Alert.js";
import swr from "swr";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoderWithoutErrorPage } from "../CommunicationV2.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../ErrorHandling.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Table } from "./Table/Table.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "./Table/Types.js";

export class InventoryHistorySubject extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "Consumable"];
    }
}

export function InventoryHistorySubject_$reflection() {
    return union_type("Widgets.StocktakingHistory.InventoryHistorySubject", [], InventoryHistorySubject, () => [[["toolId", string_type]], [["consumableId", string_type]]]);
}

export function canReadStocktakingHistory(permissions, accountSettings) {
    if ((isFeatureEnabled(new Feature(4, [])) && accountSettings.InventoryEnabled) && Permissions_has(permissions, new Permission(82, []))) {
        if (Permissions_scopeAtLeast(permissions, new Permission(82, []), new PermissionScope(4, []))) {
            return true;
        }
        else {
            return Permissions_has(permissions, new Permission(84, []));
        }
    }
    else {
        return false;
    }
}

function receiverHistoryKey(receiverId) {
    return concat("/api/stocktakings/history/receivers/", ...receiverId);
}

function inventoryHistoryKey(subject) {
    if (subject.tag === 1) {
        return concat("/api/stocktakings/history/consumables/", ...subject.fields[0]);
    }
    else {
        return concat("/api/stocktakings/history/tools/", ...subject.fields[0]);
    }
}

function setHistoryKey(setId) {
    return concat("/api/stocktakings/history/sets/", ...setId);
}

function formatDate(date) {
    return toString(toLocalTime(date), "dd.MM.yyyy");
}

function formatDateTime(date) {
    return toString(toLocalTime(date), "dd.MM.yyyy HH:mm");
}

function stocktakingRoute(stocktakingId) {
    return ["stocktaking", StocktakingId__get_unwrap(stocktakingId)];
}

function stocktakingListRoute(stocktakingId, stocktakingListId) {
    return ["stocktaking", StocktakingId__get_unwrap(stocktakingId), "lists", StocktakingListId__get_unwrap(stocktakingListId)];
}

function formatQuantity(quantity) {
    return quantity.toString();
}

function formatDifference(difference) {
    if (difference > 0) {
        return concat("+", ...formatQuantity(difference));
    }
    else {
        return formatQuantity(difference);
    }
}

function resultText(t, translateInterpreted, result) {
    switch (result.tag) {
        case 1:
            return t("stocktaking.found");
        case 2:
            return t("stocktaking.not_found");
        case 3: {
            const count = result.fields[0];
            let arg_1;
            const expected = formatQuantity(count.Expected);
            arg_1 = {
                counted: formatQuantity(count.Counted),
                difference: formatDifference(count.Counted - count.Expected),
                expected: expected,
            };
            return translateInterpreted("stocktaking.history.result_counted", arg_1);
        }
        default:
            return t("stocktaking.counting.not_counted");
    }
}

function locationText(t, location) {
    let matchResult, name;
    switch (location.tag) {
        case 1: {
            matchResult = 0;
            name = location.fields[0];
            break;
        }
        case 2: {
            matchResult = 1;
            break;
        }
        default: {
            matchResult = 0;
            name = location.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return name;
        default:
            return t("stocktaking.history.hidden_receiver");
    }
}

function recordedByText(result) {
    let matchResult, record;
    switch (result.tag) {
        case 1: {
            matchResult = 1;
            record = result.fields[0];
            break;
        }
        case 2: {
            matchResult = 1;
            record = result.fields[0];
            break;
        }
        case 3: {
            matchResult = 2;
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return "";
        case 1:
            return concat(record.RecordedBy, ", ", ...formatDateTime(record.Timestamp));
        default: {
            const count = result.fields[0];
            return concat(count.RecordedBy, ", ", ...formatDateTime(count.Timestamp));
        }
    }
}

function correctionText(t, translateInterpreted, correction) {
    let matchValue, arg_1;
    if (correction != null) {
        const correction_1 = correction;
        return `${(matchValue = correction_1.Quantity, (matchValue == null) ? t(StocktakingHistoryCorrectionKind__ToI18nString(correction_1.Kind)) : ((arg_1 = {
            quantity: formatQuantity(matchValue),
        }, translateInterpreted(StocktakingHistoryCorrectionKind__ToI18nString(correction_1.Kind), arg_1))))} - ${correction_1.CorrectedBy}, ${formatDateTime(correction_1.Timestamp)}`;
    }
    else {
        return "";
    }
}

function progressText(translateInterpreted, counted, total) {
    const arg_1 = {
        counted: counted,
        total: total,
    };
    return translateInterpreted("stocktaking.counting.progress", arg_1);
}

function deviationText(translateInterpreted, deviations) {
    const arg_1 = {
        count: deviations,
    };
    return translateInterpreted("stocktaking.history.deviation_count", arg_1);
}

function lastStocktakingLabel(head, summary) {
    return `${head.Name} - ${formatDate(defaultArg(head.CompletedAt, head.EndDate))} - ${summary}`;
}

function LastStocktakingBlock(props) {
    let elems_2;
    const t = useTranslation()[0];
    const lastCompleted = StocktakingHistory_lastCompleted(props.Heads);
    const running = StocktakingHistory_running(props.Heads);
    const runningLabel = t("stocktaking.history.running");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], ["data-test-id", "stocktaking-history-overview"], (elems_2 = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
        children: t("stocktaking.history.last_stocktaking"),
    })), delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], ["data-test-id", "stocktaking-history-last"], (elems = toList(delay(() => {
            if (lastCompleted == null) {
                return singleton(createElement(TextValue, {
                    FontWeight: "normal",
                    TestId: "",
                    Text: t("stocktaking.history.none"),
                }));
            }
            else {
                const head = lastCompleted;
                return singleton(createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: lastStocktakingLabel(head, props.Summary(head)),
                    OnClick: () => {
                        RouterModule_nav(ofArray(stocktakingRoute(head.StocktakingId)), 1, 1);
                    },
                    TestId: "stocktaking-history-last-link",
                    Variant: "blueButton",
                }));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => map((head_1) => {
            let elems_1;
            return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], ["data-test-id", "stocktaking-history-running"], (elems_1 = [createElement(TextButton, {
                ComponentState: "enabled",
                Label: `${head_1.Name} - ${runningLabel} - ${props.Summary(head_1)}`,
                OnClick: () => {
                    RouterModule_nav(ofArray(stocktakingRoute(head_1.StocktakingId)), 1, 1);
                },
                TestId: "stocktaking-history-running-link",
                Variant: "blueButton",
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        }, running)));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function HistoryState(props) {
    const patternInput = useTranslation();
    if (props.Error == null) {
        if (props.IsFetching) {
            return createElement(Skeleton, {
                Variant: "table",
            });
        }
        else {
            return props.Content;
        }
    }
    else {
        return createElement(ErrorAlert, {
            Label: patternInput[0]("stocktaking.error_fetch"),
        });
    }
}

function receiverSummary(translateInterpreted, history, head) {
    return defaultArg(map_1((entry_1) => {
        const matchValue = head.State;
        switch (matchValue.tag) {
            case 0:
            case 1:
            case 3:
            case 4:
                return deviationText(translateInterpreted, entry_1.DeviationCount);
            default:
                return progressText(translateInterpreted, entry_1.CountedCount, entry_1.PositionCount);
        }
    }, tryFind((entry) => equals(entry.Stocktaking.StocktakingId, head.StocktakingId), history.Entries)), "");
}

export function ReceiverLastStocktaking(props) {
    const patternInput = useTranslation();
    const response_2 = swr(receiverHistoryKey(props.ReceiverId), (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), ReceiverStocktakingHistoryDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    })))));
    const matchValue_1 = response_2.data;
    let matchResult;
    if (response_2.error == null) {
        if (matchValue_1 != null) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const history = matchValue_1;
            return createElement(LastStocktakingBlock, {
                Heads: map((_arg_1) => _arg_1.Stocktaking, history.Entries),
                Summary: (head) => receiverSummary((arg, arg_1) => (patternInput[1].t(arg, arg_1)), history, head),
            });
        }
        default:
            return defaultOf();
    }
}

function ReceiverHistoryTable(props) {
    let TableRows;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const matchValue = props.History.Entries;
    if (isEmpty(matchValue)) {
        return reactElement("div", {
            className: join(" ", ["p-4", "text-base"]),
            "data-test-id": "stocktaking-history-empty",
            children: t("stocktaking.history.none"),
        });
    }
    else {
        return createElement(Table, (TableRows = toArray(matchValue), {
            ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (entry) => (new CellContent(0, [entry.Stocktaking.Name])), "text", "text"), new ColumnDefinition$1("state", "", t("general.state"), (entry_1) => (new CellContent(0, [t(StocktakingState__ToI18nString(entry_1.Stocktaking.State))])), "select", "text"), new ColumnDefinition$1("startDate", "", t("general.start_date"), (entry_2) => (new CellContent(8, [entry_2.Stocktaking.StartDate])), "dateRange", "date"), new ColumnDefinition$1("endDate", "", t("general.end_date"), (entry_3) => (new CellContent(8, [entry_3.Stocktaking.EndDate])), "dateRange", "date"), new ColumnDefinition$1("completedAt", "", t("stocktaking.history.completed_at"), (entry_4) => (new CellContent(8, [entry_4.Stocktaking.CompletedAt])), "dateRange", "date"), new ColumnDefinition$1("responsiblePersons", "", t("stocktaking.responsible_person"), (entry_5) => (new CellContent(0, [join(", ", map((_arg) => _arg.Name, entry_5.Stocktaking.ResponsiblePersons))])), "text", "text"), new ColumnDefinition$1("positions", "", t("stocktaking.history.positions"), (entry_6) => (new CellContent(0, [progressText((arg, arg_1) => (patternInput[1].t(arg, arg_1)), entry_6.CountedCount, entry_6.PositionCount)])), "none", "text"), new ColumnDefinition$1("deviations", "", t("stocktaking.history.deviations"), (entry_7) => (new CellContent(0, [int32ToString(entry_7.DeviationCount)])), "none", "text")],
            Controls: empty(),
            Options: {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["startDate", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                OnRowClick: new OnTableRowClick$1(1, [(entry_8) => RouterModule_encodeParts(ofArray(stocktakingListRoute(entry_8.Stocktaking.StocktakingId, entry_8.StocktakingListId)), 1)]),
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "stocktaking-history-receiver",
            TableRows: TableRows,
        }));
    }
}

export function ReceiverStocktakingHistorySection(props) {
    let elems, matchValue;
    const response_2 = swr(receiverHistoryKey(props.ReceiverId), (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), ReceiverStocktakingHistoryDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    })))));
    return reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-history-section"], (elems = [createElement(HistoryState, {
        Content: (matchValue = response_2.data, (matchValue == null) ? defaultOf() : createElement(ReceiverHistoryTable, {
            History: matchValue,
        })),
        Error: unwrap(response_2.error),
        IsFetching: response_2.isLoading,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function inventorySummary(t, translateInterpreted, entries, head) {
    return defaultArg(map_1((entry_1) => join(" - ", map((position) => {
        const matchValue = entry_1.Positions;
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (isEmpty(tail(matchValue))) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return resultText(t, translateInterpreted, position.Result);
            default:
                return concat(locationText(t, position.Location), ": ", ...resultText(t, translateInterpreted, position.Result));
        }
    }, entry_1.Positions)), tryFind((entry) => equals(entry.Stocktaking.StocktakingId, head.StocktakingId), entries)), "");
}

export function ToolLastStocktaking(props) {
    const patternInput = useTranslation();
    const response_2 = swr(inventoryHistoryKey(new InventoryHistorySubject(0, [props.ToolId])), (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), InventoryStocktakingHistoryDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    })))));
    const matchValue_1 = response_2.data;
    let matchResult;
    if (response_2.error == null) {
        if (matchValue_1 != null) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const history = matchValue_1;
            return createElement(LastStocktakingBlock, {
                Heads: map((_arg_1) => _arg_1.Stocktaking, history.Entries),
                Summary: (head) => inventorySummary(patternInput[0], (arg, arg_1) => (patternInput[1].t(arg, arg_1)), history.Entries, head),
            });
        }
        default:
            return defaultOf();
    }
}

class InventoryHistoryRow extends Record {
    constructor(Stocktaking, Position) {
        super();
        this.Stocktaking = Stocktaking;
        this.Position = Position;
    }
}

function InventoryHistoryRow_$reflection() {
    return record_type("Widgets.StocktakingHistory.InventoryHistoryRow", [], InventoryHistoryRow, () => [["Stocktaking", StocktakingHistoryHeadDto_$reflection()], ["Position", StocktakingHistoryPositionDto_$reflection()]]);
}

function InventoryHistoryTable(props) {
    let TableRows;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18n = patternInput[1];
    const rows = collect((entry) => map((position) => (new InventoryHistoryRow(entry.Stocktaking, position)), entry.Positions), props.Entries);
    if (isEmpty(rows)) {
        return reactElement("div", {
            className: join(" ", ["p-4", "text-base"]),
            "data-test-id": "stocktaking-history-empty",
            children: t("stocktaking.history.none"),
        });
    }
    else {
        return createElement(Table, (TableRows = toArray(rows), {
            ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.Stocktaking.Name])), "text", "text"), new ColumnDefinition$1("state", "", t("general.state"), (row_1) => (new CellContent(0, [t(StocktakingState__ToI18nString(row_1.Stocktaking.State))])), "select", "text"), new ColumnDefinition$1("endDate", "", t("general.end_date"), (row_2) => (new CellContent(8, [row_2.Stocktaking.EndDate])), "dateRange", "date"), new ColumnDefinition$1("completedAt", "", t("stocktaking.history.completed_at"), (row_3) => (new CellContent(8, [row_3.Stocktaking.CompletedAt])), "dateRange", "date"), new ColumnDefinition$1("location", "", t("stocktaking.history.location"), (row_4) => (new CellContent(0, [locationText(t, row_4.Position.Location)])), "text", "text"), new ColumnDefinition$1("result", "", t("stocktaking.result"), (row_5) => (new CellContent(0, [resultText(t, (arg, arg_1) => (i18n.t(arg, arg_1)), row_5.Position.Result)])), "text", "text"), new ColumnDefinition$1("recordedBy", "", t("stocktaking.recorded_by"), (row_6) => (new CellContent(0, [recordedByText(row_6.Position.Result)])), "text", "text"), new ColumnDefinition$1("correction", "", t("stocktaking.history.correction"), (row_7) => (new CellContent(0, [correctionText(t, (arg_2, arg_3) => (i18n.t(arg_2, arg_3)), row_7.Position.Correction)])), "text", "text")],
            Controls: empty(),
            Options: {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["endDate", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                OnRowClick: new OnTableRowClick$1(1, [(row_8) => RouterModule_encodeParts(ofArray(stocktakingListRoute(row_8.Stocktaking.StocktakingId, row_8.Position.StocktakingListId)), 1)]),
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "stocktaking-history-inventory",
            TableRows: TableRows,
        }));
    }
}

export function InventoryStocktakingHistorySection(props) {
    let elems, matchValue;
    const response_2 = swr(inventoryHistoryKey(props.Subject), (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), InventoryStocktakingHistoryDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    })))));
    return reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-history-section"], (elems = [createElement(HistoryState, {
        Content: (matchValue = response_2.data, (matchValue == null) ? defaultOf() : createElement(InventoryHistoryTable, {
            Entries: matchValue.Entries,
        })),
        Error: unwrap(response_2.error),
        IsFetching: response_2.isLoading,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function useSetStocktakingHistoryIf(enabled, setId) {
    return swr(enabled ? setHistoryKey(setId) : "", (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), SetStocktakingHistoryDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    }))))).data;
}

export function setToolLastStocktakingCell(t, translateInterpreted, toolStocktakings, toolId) {
    const matchValue = tryFind((entry) => (ToolId__get_unwrap(entry.ToolId) === toolId), toolStocktakings);
    if (matchValue == null) {
        return new CellContent(0, [t("stocktaking.history.none")]);
    }
    else {
        const entry_1 = matchValue;
        return new CellContent(1, [lastStocktakingLabel(entry_1.Stocktaking, resultText(t, translateInterpreted, entry_1.Result)), RouterModule_encodeParts(ofArray(stocktakingRoute(entry_1.Stocktaking.StocktakingId)), 1)]);
    }
}

export function SetStocktakingHistorySection(props) {
    let elems, matchValue;
    const response_2 = swr(setHistoryKey(props.SetId), (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoderWithoutErrorPage(addPrefix(url), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), SetStocktakingHistoryDto_$reflection()));
    }).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    })))));
    return reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-history-section"], (elems = [createElement(HistoryState, {
        Content: (matchValue = response_2.data, (matchValue == null) ? defaultOf() : createElement(InventoryHistoryTable, {
            Entries: matchValue.Entries,
        })),
        Error: unwrap(response_2.error),
        IsFetching: response_2.isLoading,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

